module.exports = __webpack_public_path__ + "static/img/zhinengkongzhi.332cde09.png";